import { HandleBookOfMindTurnPageRequest } from "../../../presentation/MainPanel/Workflows/BookOfMind/Tools/TurnPageLink/Helpers/HandleBookOfMindTurnPageRequest";
import { IKeyboardEvent, TKeyboardEvent } from "./IKeyboardEvents";

const Reload: IKeyboardEvent = {
    hotkeyDescription: `Right`,
    actionDescription: `Reload quotes`,
    trigger: (event: TKeyboardEvent) => event.keyCode == 39,
    action: () => HandleBookOfMindTurnPageRequest(),
};

export const bookOfMindKeyboardEvents: IKeyboardEvent[] = [Reload];
